/* Built In Imports */
/* External Imports */
import { Box, Image, Text } from '@chakra-ui/react';
import MediaEmbedV2 from '@components/Embeds/MediaEmbedV2';
import SectionTitle from '@components/Headings/SectionTitle';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import SingleLineText from '@components/UI/SingleLineText';
import { LeftQuote } from '../components/Icon/LeftQuote';
import config from '@config';
/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const Quotes = ({ sectionContent, region, language }) => {
    return (
            <Box
                bgImage={{base:'', md:`url(${config.imgPath}/d/46272/1733835027-left_quotes.png)`}}
                bgRepeat={'no-repeat'}
                bgPosition={'left 40px'}
                width={'100%'}
            >
                <Box 
                    bgImage={{base:'', md:`url(${config.imgPath}/d/46272/1733835195-right_quote.png)`}}
                    bgRepeat={'no-repeat'}
                    bgPosition={'right 80%'}
                    width={'100%'}
                >
                    <Box width={{ base: "286px", sm: "286px", md: '532px', lg: "532px" }}
                        display={"flex"} flexDirection={"column"}
                        alignItems={"center"}
                        fontFamily={"FedraSansStd-book"}
                        margin={'auto'}
                        paddingTop={{base:'35%', sm:'35%', lg:'7%', md:'7%'}}
                    >
                        <LeftQuote />
                        <Box
                            color="#000000"
                            textAlign="center"
                            fontFamily={"FedraSansStd-book"}
                            fontSize={{ base: '18px', lg: '22px' }}
                            fontStyle="italic"
                            fontWeight="400"
                            lineHeight="32.12px"
                            marginTop={"20px"}
                        >
                            {sectionContent[0].quote}
                        </Box>
                        <LazyLoadImageComponent
                            src="https://static.sadhguru.org/d/46272/1733532044-sadhguru_signature.svg"
                            w="137px"
                            h="64px"
                            alt="isha logo"
                            objectFit="contain"
                            my={{ base: '30px', md: '30px' }}
                        />
                    </Box>
                </Box>
            </Box>
    );
};

export default Quotes;
